import * as React from 'react'
import { FC } from 'react'
import { cls, markedWithSanitize } from '../../utils/utils'
import * as styles from './SimpleMarkdown.module.scss'

interface IProps {
  body?: string
  className?: string
}

const SimpleMarkdown: FC<IProps> = ({ className, body }) => {
  return body ? <div className={cls(styles.markdown, className)} dangerouslySetInnerHTML={{ __html: markedWithSanitize(body) }} /> : null
}

export default SimpleMarkdown
